import { AuthProvider } from "./contexts/AuthContext";
import { AnnotationProvider } from "./contexts/AnnotationContext";
import { NavbarProvider } from "./contexts/NavbarContext";
import { ExportedFramesProvider } from "./store/exportedFrames";
import { VideoUploadPopoverProvider } from "./contexts/VideoUploadPopoverContext";
import ToastProvider from "./components/shared/ToastProvider";
import WebSocketWithToken from "./components/shared/WebSocketWithToken";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/queryClient";

function AppProviders({ children }) {
  return (
    <ToastProvider>
      <ExportedFramesProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AnnotationProvider>
              <NavbarProvider>
                <VideoUploadPopoverProvider>
                  <WebSocketWithToken>{children}</WebSocketWithToken>
                </VideoUploadPopoverProvider>
              </NavbarProvider>
            </AnnotationProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ExportedFramesProvider>
    </ToastProvider>
  );
}

export default AppProviders;
